import { basic, initSidebar, initTopbar } from './modules/layouts';
import { initLocaleDatetime, imgLazy } from './modules/plugins';

basic();
initSidebar();
initTopbar();
initLocaleDatetime();
imgLazy();
